import './public/assets/Content.css';

import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { FAD_Button_Outline, FAD_Button_Primary } from '../components/FadButtons';
import { IoIosArrowBack, IoMdArrowDown, IoMdArrowUp } from 'react-icons/io';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Collapse, ColorPicker, ConfigProvider, Divider, Input, Select, Skeleton, Switch } from 'antd';
import { FaPlay } from 'react-icons/fa';
import { BsFillSendFill } from 'react-icons/bs';
import Colors from 'enums/Colors';
import { MdArrowUpward, MdDeleteForever, MdEditSquare, MdOutlineSettings, MdPublic, MdSaveAs } from 'react-icons/md';
import FadAdds from '../components/adds/FadAdds';
import useFetch from 'hooks/useFetch';
import { FadModulesService } from 'core/http/service/ferramentaAutoria/FadModules.service';
import { FadModulesModel } from 'models/ferramentaAutoria/FadModulesModel';
import ModalFormModule from '../components/modals/ModalFormModule';
import { FadContentsModel } from 'models/ferramentaAutoria/FadContentsModel';
import { FadContentsService } from 'core/http/service/ferramentaAutoria/FadContents.service';
import AdminFadMenuLateral from '../components/menuLateral/AdminFadMenuLateral';
import { ComponentInteractionService } from 'core/http/service/componetInteraction/ComponentInteraction.service';
import ComponentInteractionSimpleModel from 'models/componentInteraction/ComponentInterationSimple';
import { ToastSuccess } from 'components/Toaster';
import ComponentInteractionModel from 'models/componentInteraction/ComponentInteraction';
import { ComponentInteractionEnum } from 'enums/ComponentInteractionEnum';
import ReactQuill from 'react-quill';
import editorConfig from 'pages/diarioBordo/components/textEditor/editorConfig';
// Ignore TypeScript complaints about importing CSS as a side-effect
// because project uses custom declarations for stylesheets elsewhere.
// @ts-ignore
import '../components/essentials/reactQuill.css';
import ImageUpload from 'components/uploader/ImageUpload';
import AddNewComponent from '../components/essentials/AddNewComponent';
import FunctionsFAD from '../helpers/FunctionsFAD';
import { ComponentInteractionAnexo } from 'models/componentInteraction/ComponentInteractionAnexo';
import QuizInteractionAdmin from 'pages/gestao_paginas/components/interactions/QuizInteractionAdmin';
import ComponentQuizModel from 'models/componentInteraction/ComponentQuiz';
import ComponentQuizAlternativasModel from 'models/componentInteraction/ComponentQuizAlternativas';
import { ComponentQuizService } from 'core/http/service/componetInteraction/ComponentQuiz.service';
import ComponentReguaAvaliativaAdmin from 'pages/gestao_paginas/components/interactions/ComponentReguaAvaliativaAdmin';
import ComponentQuizPontucaoAdmin from 'pages/gestao_paginas/components/interactions/ComponentQuizPontucaoAdmin';
import SanfonaInteractionAdmin from 'pages/gestao_paginas/components/interactions/SanfonaInteractionAdmin';
import { Option } from 'antd/es/mentions';
import { CaretRightOutlined } from '@ant-design/icons';
import ComponentSanfonaModel from 'models/componentInteraction/ComponentSanfona';
import CorrespondenciaInteractionAdmin from 'pages/gestao_paginas/components/interactions/CorrespondenciaInteractionAdmin';
import CorrespondentItemModel from 'models/componentInteraction/CorrespondentItemModel';
import CarrosselInteractionAdmin from 'pages/gestao_paginas/components/interactions/CarrosselInteractionAdmin';
import ComponentItemCarrosselInteraction from 'models/componentInteraction/ComponentItemCarrosselInteraction';
import ComponentBaralhoAdmin from 'pages/gestao_paginas/components/interactions/ComponentBaralhoAdmin';
import ComponentTimeLineAdmin from 'pages/gestao_paginas/components/interactions/ComponentTimeLineAdmin';
import ComponentCenarioAdmin from 'pages/gestao_paginas/components/interactions/ComponentCenarioAdmin';
import ComponentAbasAdmin from 'pages/gestao_paginas/components/interactions/ComponentAbasAdmin';
import ComponentAbasModel from 'models/componentInteraction/ComponentAbas';
import { Form, Modal } from 'react-bootstrap';
import ModalFormContent from '../components/modals/ModalFormContent';
import { FadRelationsTemplateService } from 'core/http/service/ferramentaAutoria/FadRelationsTemplate.service';
import { HiLockClosed } from 'react-icons/hi';
import { FadModulesAnexoModel } from 'models/ferramentaAutoria/FadModulesAnexoModel';
import { FadModulesAnexoService } from 'core/http/service/ferramentaAutoria/FadModulesAnexo.service';
import ComponentDividersAdmin from 'pages/gestao_paginas/components/interactions/ComponentDividersAdmin';
import CompontentMarksAdmin from 'pages/gestao_paginas/components/interactions/CompontentMarksAdmin';
import ComponentHostPot from 'pages/gestao_paginas/components/interactions/ComponentHostPotAdmin';
import ComponentHostpotModel from 'models/componentInteraction/ComponentHostPot';
import { FadClassesService } from 'core/http/service/ferramentaAutoria/FadClasses.service';
import { FadClassesModel } from 'models/ferramentaAutoria/FadClassesModel';
import ComponentInteractionClasse from 'models/componentInteraction/ComponentInteractionClasse';
import ComponentArrasteSolteAdmin from 'pages/gestao_paginas/components/interactions/ComponentArrasteSolteAdmin';
import ComponentGameMemoryAdmin from 'pages/gestao_paginas/components/interactions/ComponentGameMemoryAdmin';
import ComponentLacunasAdmin from 'pages/gestao_paginas/components/interactions/ComponentLacunasAdmin';
import ComponentCorrespondentImagemAdmin from 'pages/gestao_paginas/components/interactions/ComponentCorrespondentImagemAdmin';
import { log } from 'console';
import { FerramentaAutoriaContext } from '../context/FerramentaAutoriaContext';
import { set } from 'js-cookie';
import AdminModalFadPreview from './public/AdminModalFadPreview';
import { ComponentInteractionPositionEnum } from 'enums/ComponentInteractionPositionEnum';
import { useScrollRestore } from '../helpers/useScrollRestore';

const StyledCaretRightOutlined = styled(CaretRightOutlined)``;

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        padding-bottom: 40px;
        overflow: hidden;
        background-color: ${Colors.White};
        padding: 22px;
    `,

    Header: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 80px;
        border-bottom: 1px solid #999999;
    `,

    Buttons: styled.div`
        display: flex;
        gap: 16px;
    `,

    ContentInfoModule: {
        Container: styled.div`
            display: flex;
            flex-direction: column;
            gap: 12px;
            border-bottom: 1px solid #999999;
            margin: 20px 0px;
            padding-bottom: 20px;
        `,
    },

    LabelInput: styled.p`
        //styleName: Base/Legenda;
        font-family: 'Barlow';
        font-size: 14px;
        font-weight: 400;
        line-height: 15.6px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    `,

    RowEnd: styled.div`
        display: flex;
        justify-content: end;
        align-items: center;
    `,

    RowBettween: styled.div`
        display: flex;
        justify-content: space-between;
    `,

    TitleLarge: styled.h1`
        //styleName: Base/H2;
        font-family: 'Barlow';
        font-size: 36px;
        font-weight: 700;
        line-height: 43.2px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    `,

    Content: {
        Cotainer: styled.div`
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            margin-bottom: 20px;
        `,

        Body: styled.div`
            display: flex;
            flex-direction: column;
            border-top: 2px dashed;
            border-bottom: 2px dashed;
            padding: 12px 4px;
        `,
    },

    ContentComponentInteractions: styled.div`
        display: flex;
        flex-direction: column;
        gap: 1rem;
    `,

    Row: styled.div`
        display: flex;
        gap: 1rem;
    `,

    Column: styled.div`
        display: flex;
        flex-direction: column;
        gap: 1rem;
    `,

    InputSanfona: styled.input<{ colorSelected: string }>`
        border: none;
        border-bottom: 1px solid #d9d9d9;
        width: 80%;
        height: 42px;
        padding-left: 10px;
        font-size: 18px;
        font-weight: 700;
        color: ${({ colorSelected }) => (colorSelected === Colors.Blue || colorSelected === Colors.SoftBlue ? Colors.White : Colors.Blue)};
        background-color: ${({ colorSelected }) => colorSelected};

        &:focus {
            outline: none;
        }
    `,

    Divisor: styled.div<{ width?: string }>`
        display: flex;
        flex-direction: column;
        width: ${props => (props.width ? props.width : 'auto')};
        margin: 10px;
    `,

    Label: styled.div`
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        color: #00a8e9;
        margin-bottom: 10px;
    `,
};

interface IContents {
    dados: FadContentsModel;
    addNewComponente: (ordem: number) => void;
    handleSettings: () => void;
    components: ComponentInteractionModel[];
    attComponents: (value: any) => void;
    classes: FadClassesModel[];
}

const Contents = ({ dados, addNewComponente, components, handleSettings, attComponents, classes }: IContents) => {
    const [allComponents, setAllComponents] = useState<ComponentInteractionModel[]>(components);
    const [anexosComponents, setAnexoComponent] = useState<ComponentInteractionAnexo[]>([]);
    const [quizIndex, setQuizIndex] = useState<number>(0);

    //hostpost
    const [hostpost, setHostpost] = useState<ComponentHostpotModel[]>([]);

    //loaders
    const [loaderComponents, setLoaderComponents] = useState<boolean>(true);
    const [loadingButton, setLoadingButton] = useState<number>(-1);

    //helper do scroll
    const { saveScrollPosition, restoreScrollPosition } = useScrollRestore();

    const serviceComponentInteraction = new ComponentInteractionService();
    const serviceComponentQuiz = new ComponentQuizService();

    const handleSaveComponentInteraction = async (component: ComponentInteractionModel) => {
        if (component.tipo === ComponentInteractionEnum.HOSTPOT) {
            component.hostpots = hostpost;
        }

        // Preservar a posição de scroll atual
        const scrollPosition = window.scrollY;

        const data = await FunctionsFAD.handleSaveComponent(component);

        attComponents((prev: any) =>
            prev.map((c: ComponentInteractionModel) => {
                if (c.id === data.id) {
                    return data;
                }

                return c;
            })
        );
        setLoadingButton(-1);

        // Restaurar a posição de scroll após salvar
        window.scrollTo(0, scrollPosition);
    };

    const handleUpdateObrigatoryComponent = async (component: ComponentInteractionModel, obrigatory: boolean, saveAuto: boolean) => {
        if (saveAuto) {
            const comp = { ...component } as ComponentInteractionModel;
            comp.obrigatory = obrigatory;

            await handleSaveComponentInteraction(comp);
        } else {
            attComponents((prev: any) =>
                prev.map((c: ComponentInteractionModel) => {
                    if (c.id === component.id) {
                        return { ...c, obrigatory: obrigatory };
                    }

                    return c;
                })
            );
        }
    };

    const handleRemoveComponent = async (index: number, model: ComponentInteractionModel) => {
        saveScrollPosition();

        if (model.id != null) {
            const response = await serviceComponentInteraction.deleteById(model.id);

            if (response.status === 204) {
                ToastSuccess('Componente deletado com sucesso!');
            }
        }

        if (allComponents.length === 1) {
            setAllComponents([]);
        } else {
            attComponents((prevInteractions: any) => prevInteractions.filter((m: ComponentInteractionModel, idx: number) => m.id !== model.id));
        }

        setLoadingButton(-1);
        restoreScrollPosition();
    };

    const atualizarComponentInteraction = (indexComponent: number, component: ComponentInteractionModel) => {
        setAllComponents((prevInteractions: any) =>
            prevInteractions.map((item: any, idx: number) => (idx === indexComponent ? component : item))
        );
    };

    const handleSetCor = (value: string, index: number) => {
        setAllComponents((prevInteractions: any) =>
            prevInteractions.map((item: ComponentInteractionModel, idx: number) => (idx === index ? { ...item, cor: value } : item))
        );
    };

    const handleAtualizationTitleSanfona = (value: string, idxComponent: number, idxSanfona: number) => {
        setAllComponents((prevInteractions: any) =>
            prevInteractions.map((item: ComponentInteractionModel, idx: number) => {
                if (idx === idxComponent && item.sanfona) {
                    return {
                        ...item,
                        sanfona: item.sanfona.map((sanfona, sIdx) => (sIdx === idxSanfona ? { ...sanfona, titulo: value } : sanfona)),
                    };
                }
                return item;
            })
        );
    };

    const handleAtualizationConteudoSanfona = (
        conteudo: string,
        tipoConteudo: ComponentInteractionEnum,
        idxComponent: number,
        idxSanfona: number,
        idxConteudo: number
    ) => {
        setAllComponents((prevInteractions: any[]) =>
            prevInteractions.map((item, idx) => {
                if (idx === idxComponent && item.sanfona) {
                    return {
                        ...item,
                        sanfona: item.sanfona.map((sanfona: ComponentSanfonaModel, sIdx: number) =>
                            sIdx === idxSanfona && sanfona.componentSanfonaConteudos
                                ? {
                                      ...sanfona,
                                      componentSanfonaConteudos: sanfona.componentSanfonaConteudos.map((conteudoItem, cIdx) =>
                                          cIdx === idxConteudo
                                              ? {
                                                    ...conteudoItem,
                                                    conteudo,
                                                    tipoConteudo,
                                                }
                                              : conteudoItem
                                      ),
                                  }
                                : sanfona
                        ),
                    };
                }
                return item;
            })
        );
    };

    const handleAddNewAbaSanfona = (idxComponent: number) => {
        setAllComponents((prevInteractions: any) =>
            prevInteractions.map((item: ComponentInteractionModel, idx: number) => {
                if (idx === idxComponent) {
                    return {
                        ...item,
                        sanfona: [
                            ...(item.sanfona || []),
                            new ComponentSanfonaModel(), // Criação de uma nova aba
                        ],
                    };
                }
                return item;
            })
        );
    };

    const handleAddConteudoSanfona = (conteudo: string, tipoConteudo: ComponentInteractionEnum, idxComponent: number, idxSanfona: number) => {
        setAllComponents((prevInteractions: any) =>
            prevInteractions.map((item: ComponentInteractionModel, idx: number) => {
                if (idx === idxComponent && item.sanfona) {
                    return {
                        ...item,
                        sanfona: item.sanfona.map((sanfona, sIdx) => {
                            if (sIdx === idxSanfona) {
                                const currentConteudos = Array.isArray(sanfona.componentSanfonaConteudos)
                                    ? sanfona.componentSanfonaConteudos
                                    : []; // Garante que seja uma lista

                                return {
                                    ...sanfona,
                                    componentSanfonaConteudos: [
                                        ...currentConteudos,
                                        {
                                            id: -1,
                                            conteudo,
                                            tipoConteudo,
                                        },
                                    ],
                                };
                            }
                            return sanfona;
                        }),
                    };
                }
                return item;
            })
        );
    };

    const handleNewQuiz = (indexComponent: number) => {
        saveScrollPosition();

        const quiz = new ComponentQuizModel();
        let component = allComponents[indexComponent];

        component.quiz?.push(quiz);

        atualizarComponentInteraction(indexComponent, component);

        setQuizIndex((component.quiz?.length ?? 1) - 1);

        setTimeout(() => {
            restoreScrollPosition();
        }, 0);
    };

    const handleNavigateQuiz = (next: boolean, length: number) => {
        if (!next) {
            if (quizIndex > 0) {
                setQuizIndex(quizIndex - 1);
            }
        } else {
            if (quizIndex + 1 < length) {
                setQuizIndex(quizIndex + 1);
            }
        }
    };

    const atualizarPerguntaQuiz = (indexComponent: number, indexQuiz: number, pergunta: string) => {
        let component = allComponents[indexComponent];

        if (component.quiz) component.quiz[indexQuiz].pergunta = pergunta;

        atualizarComponentInteraction(indexComponent, component);
    };

    const atualizarFeedbackQuiz = (indexComponent: number, indexQuiz: number, feedback: string) => {
        let component = allComponents[indexComponent];

        if (component.quiz) component.quiz[indexQuiz].feedback = feedback;

        atualizarComponentInteraction(indexComponent, component);
    };

    const adicionarNovaAlternativaQuiz = (indexComponent: number, indexQuiz: number) => {
        let component = allComponents[indexComponent];

        if (component.quiz) component.quiz[indexQuiz].alternativas?.push(new ComponentQuizAlternativasModel());

        atualizarComponentInteraction(indexComponent, component);
    };

    const atualizarAlternativaQuiz = (indexComponent: number, indexQuiz: number, indexAlternativa: number, alternativa: string) => {
        let component = allComponents[indexComponent];

        if (component && component.quiz) {
            const quizItem = component.quiz[indexQuiz];

            if (quizItem && quizItem.alternativas && Array.isArray(quizItem.alternativas)) {
                if (indexAlternativa >= 0 && indexAlternativa < quizItem.alternativas.length) {
                    quizItem.alternativas[indexAlternativa].alternativa = alternativa;
                }
            }
        }

        atualizarComponentInteraction(indexComponent, component);
    };

    const removerAlternativaQuiz = async (indexComponent: number, indexQuiz: number, indexAlternativa: number) => {
        let component = allComponents[indexComponent];

        if (component && component.quiz) {
            let quizItem = component.quiz[indexQuiz];

            if (quizItem && quizItem.alternativas && Array.isArray(quizItem.alternativas)) {
                if (indexAlternativa >= 0 && indexAlternativa < quizItem.alternativas.length) {
                    let alternativa: ComponentQuizAlternativasModel = quizItem.alternativas[indexAlternativa];

                    const response = await serviceComponentQuiz.deletarAlternativaQuiz(alternativa.id);

                    if (response.status === 204) {
                        ToastSuccess('Alternativa excluída com sucesso!');

                        quizItem.alternativas.splice(indexAlternativa, 1);
                    }
                }
            }
        }

        atualizarComponentInteraction(indexComponent, component);
    };

    const atualizarCheckAlternativa = (indexComponent: number, indexQuiz: number, indexAlternativa: number, checked: boolean) => {
        let component = allComponents[indexComponent];

        if (component && component.quiz) {
            const quizItem = component.quiz[indexQuiz];

            if (quizItem && quizItem.alternativas && Array.isArray(quizItem.alternativas)) {
                if (indexAlternativa >= 0 && indexAlternativa < quizItem.alternativas.length) {
                    if (quizItem.multiplos) {
                        quizItem.alternativas[indexAlternativa].correct = checked;
                    } else {
                        quizItem.alternativas.map((alt, index) => {
                            if (alt.correct) {
                                return (alt.correct = false);
                            }
                        });

                        quizItem.alternativas[indexAlternativa].correct = checked;
                    }
                }
            }
        }

        atualizarComponentInteraction(indexComponent, component);
    };

    const atualizarObrigatoryQuiz = (indexComponent: number, obrigatory: boolean) => {
        let component = allComponents[indexComponent];

        component.obrigatory = obrigatory;

        atualizarComponentInteraction(indexComponent, component);
    };

    const atualizarMultiplos = (indexComponent: number, indexQuiz: number, multiplos: boolean) => {
        let component = allComponents[indexComponent];

        if (component.quiz) {
            component.quiz[indexQuiz].multiplos = multiplos;

            if (!multiplos) {
                const quizItem = component.quiz[indexQuiz];

                if (quizItem && quizItem.alternativas && Array.isArray(quizItem.alternativas)) {
                    quizItem.alternativas.map((alt, index) => {
                        if (alt.correct) {
                            return (alt.correct = false);
                        }
                    });
                }
            }
        }

        atualizarComponentInteraction(indexComponent, component);
    };

    const deletarQuiz = async (indexComponent: number, indexQuiz: number) => {
        let component = allComponents[indexComponent];

        if (component.quiz) {
            let quizItem = component.quiz[indexQuiz];

            const response = await serviceComponentQuiz.deletarQuiz(quizItem.id);

            if (response.status === 204) {
                ToastSuccess('Quiz excluído com sucesso!');

                component.quiz.splice(indexQuiz, 1);

                if (component.quiz.length === 0) return handleRemoveComponent(indexComponent, component);
            }
        }

        atualizarComponentInteraction(indexComponent, component);

        setQuizIndex(indexQuiz > 0 ? (indexQuiz ?? 1) - 1 : 0);
    };

    const handleSaveImg = async (id: number, img: string) => {
        // Buscar o anexo correspondente
        const existingAnexo = anexosComponents.find(a => a.codigoComponent === id);

        // Criar o objeto anexo
        const anexo = new ComponentInteractionAnexo().fromJSON({
            id: existingAnexo?.id ?? -1,
            filepath: existingAnexo?.filepath ?? '',
            base64: img,
        });

        // Chamada à função para inserir/atualizar o anexo
        const data = await FunctionsFAD.insertAndUpdateAnexoComponentInteraction(anexo, id);

        // Atualizar a lista de anexos, removendo o antigo e adicionando o novo
        setAnexoComponent((prev: ComponentInteractionAnexo[]) => {
            // Verificar se o anexo já existe na lista
            const filtered = prev.filter(a => a.id !== data.id);
            return [...filtered, data];
        });
    };

    const handleItemCarrossel = (indexComponent: number, itensCarrossel: ComponentItemCarrosselInteraction[]) => {
        let component = components[indexComponent];

        if (component && component.carrossel) {
            let carrosselItem = component.carrossel;

            if (carrosselItem) {
                carrosselItem.itens = itensCarrossel;
            }
        }

        atualizarComponentInteraction(indexComponent, component);
    };

    const handleAtualizarCorrespondent = (indexComponent: number, value: string, isPerguta?: boolean) => {
        let component = components[indexComponent];

        if (component && component.correspondent) {
            const correspondent = component.correspondent;

            if (isPerguta) {
                correspondent.pergunta = value;
            }

            if (!isPerguta) {
                correspondent.feedback = value;
            }
        }

        atualizarComponentInteraction(indexComponent, component);
    };

    const handleItemCorrespondent = (indexComponent: number, itens: CorrespondentItemModel[]) => {
        let component = components[indexComponent];

        if (component && component.correspondent) {
            const correspondent = component.correspondent;

            correspondent.itens = itens;
        }

        atualizarComponentInteraction(indexComponent, component);
    };

    const atualizarQuantityVisible = (indexComponent: number, quantity: number) => {
        let component = components[indexComponent];

        component.quantityVisible = quantity;

        atualizarComponentInteraction(indexComponent, component);
    };

    const handleAbas = (indexComponent: number, abas: ComponentAbasModel[]) => {
        let component = components[indexComponent];

        if (component && component.abas) {
            component.abas = abas;
        }

        atualizarComponentInteraction(indexComponent, component);
    };

    const moveComponent = async (index: number, direction: 'up' | 'down') => {
        saveScrollPosition();
        const newComponents = [...allComponents];

        // Obter o componente atual que queremos mover
        const currentComponent = newComponents[index];

        // Encontrar o índice do componente que deve ser trocado
        const targetIndex = direction === 'up' ? index - 1 : index + 1;

        // Verificar se o índice de destino é válido
        if (targetIndex < 0 || targetIndex >= newComponents.length) {
            return; // Não faz nada se o índice for inválido
        }

        const targetComponent = newComponents[targetIndex];

        // Verificar se os componentes pertencem ao mesmo grupo (codigoContent)
        if (currentComponent.codigoContent === targetComponent.codigoContent) {
            // Trocar as ordens
            const tempOrder = currentComponent.ordem;
            currentComponent.ordem = targetComponent.ordem;
            targetComponent.ordem = tempOrder;

            //Atualizar a ordem.
            const response1 = await serviceComponentInteraction.atualizarOrdem(currentComponent);
            const response2 = await serviceComponentInteraction.atualizarOrdem(targetComponent);

            if (response1.status === 204 && response2.status === 204) {
                ToastSuccess('Modificação na ordem realizada com sucesso!');
                // Atualizar o estado com a nova lista de componentes
                const orderedComponents = [...newComponents].sort((a, b) => a.ordem - b.ordem);
                setAllComponents(orderedComponents);
            }
        }
        restoreScrollPosition();
    };

    const handleCustomImagemComponentInteraction = (codigo: number, value: boolean) => {
        setAllComponents((prev: any) =>
            prev.map((c: ComponentInteractionModel) => {
                if (c.id === codigo) {
                    return {
                        ...c,
                        customImg: value,
                    };
                }
                return c;
            })
        );
    };

    const handleColorComponentInteraction = (codigo: number, value: string) => {
        setAllComponents((prev: any) =>
            prev.map((c: ComponentInteractionModel) => {
                if (c.id === codigo) {
                    return {
                        ...c,
                        cor: value,
                    };
                }

                return c;
            })
        );
    };

    const handleSizeImgComponentInteraction = (codigo: number, isWidth: boolean, value: string) => {
        setAllComponents((prev: any) =>
            prev.map((c: ComponentInteractionModel) => {
                if (c.id === codigo) {
                    return {
                        ...c,
                        sizeImgWidth: isWidth ? value : c.sizeImgWidth,
                        sizeImgHeight: !isWidth ? value : c.sizeImgHeight,
                    };
                }
                return c;
            })
        );
    };

    const handlePositionImgComponentInteraction = (codigo: number, value: string) => {
        setAllComponents((prev: any) =>
            prev.map((c: ComponentInteractionModel) => {
                if (c.id === codigo) {
                    return {
                        ...c,
                        positionImg: value,
                    };
                }
                return c;
            })
        );
    };

    const FooterOptions = (
        index: number,
        component: ComponentInteractionModel,
        numberLoading: number,
        classes: FadClassesModel[],
        justTheOptionToDelete?: boolean,
        justTheOptionObrigatoty?: boolean
    ) => {
        return (
            <>
                <Styled.Column>
                    <Styled.Row style={{ alignItems: 'center', marginTop: 22, zIndex: 1 }}>
                        {!justTheOptionToDelete && (
                            <FAD_Button_Outline
                                onClick={() => {
                                    setLoadingButton(numberLoading);
                                    handleSaveComponentInteraction(component);
                                }}
                                text=""
                                icon={<MdSaveAs size={26} />}
                                styles={{ width: 200 }}
                                loading={loadingButton === numberLoading}
                            />
                        )}
                        <FAD_Button_Outline
                            onClick={() => {
                                setLoadingButton(10 + numberLoading);
                                handleRemoveComponent(index, component);
                            }}
                            text="Remover componente"
                            styles={{ width: 240 }}
                            icon={<MdDeleteForever size={26} />}
                            remove
                            loading={loadingButton === 10 + numberLoading}
                        />

                        {justTheOptionObrigatoty && component.id != -1 && (
                            <Switch
                                value={component.obrigatory ?? false}
                                checkedChildren="Obrigatório"
                                unCheckedChildren="Obrigatório"
                                onChange={c => handleUpdateObrigatoryComponent(component, c, justTheOptionToDelete === true)}
                            />
                        )}

                        <IoMdArrowUp size={26} cursor={'pointer'} onClick={() => moveComponent(index, 'up')} />
                        <IoMdArrowDown size={26} cursor={'pointer'} onClick={() => moveComponent(index, 'down')} />

                        {(component.tipo === ComponentInteractionEnum.TEXT_IMG_LEFT ||
                            component.tipo === ComponentInteractionEnum.TEXT_IMG_RIGHT) && (
                            <>
                                <Switch
                                    style={{ marginLeft: 20 }}
                                    checked={component.customImg ?? false}
                                    onChange={v => handleCustomImagemComponentInteraction(component.id, v)}
                                    checkedChildren="Imagem personalizada"
                                    unCheckedChildren="Imagem personalizada"
                                />

                                {component.customImg && (
                                    <>
                                        <Styled.Label style={{ marginLeft: 20 }}>Largura da imagem:</Styled.Label>
                                        <Input
                                            style={{ width: 100, marginRight: 10 }}
                                            value={component.sizeImgWidth ?? ''}
                                            onChange={e => handleSizeImgComponentInteraction(component.id, true, e.target.value)}
                                            placeholder="Ex: 200px ou 50%"
                                        />
                                        <Styled.Label style={{ marginLeft: 20 }}>Altura da imagem:</Styled.Label>
                                        <Input
                                            style={{ width: 100 }}
                                            value={component.sizeImgHeight ?? ''}
                                            onChange={e => handleSizeImgComponentInteraction(component.id, false, e.target.value)}
                                            placeholder="Ex: 200px ou 50%"
                                        />
                                        <Styled.Label style={{ marginLeft: 20 }}>Posição da imagem:</Styled.Label>
                                        <Select
                                            style={{ width: 150, marginLeft: 10 }}
                                            value={component.positionImg ?? ComponentInteractionPositionEnum.CENTER}
                                            onChange={v => handlePositionImgComponentInteraction(component.id, v)}
                                        >
                                            <Select.Option value={ComponentInteractionPositionEnum.TOP}>Topo</Select.Option>
                                            <Select.Option value={ComponentInteractionPositionEnum.CENTER}>Centro</Select.Option>
                                            <Select.Option value={ComponentInteractionPositionEnum.BOTTOM}>Rodapé</Select.Option>
                                        </Select>
                                    </>
                                )}
                            </>
                        )}
                    </Styled.Row>
                    <Select
                        mode="multiple"
                        allowClear
                        placeholder="Classes"
                        size="large"
                        value={classes
                            .filter(cc => {
                                return component.classes?.some(c1 => c1.fadClasses === cc.codigo);
                            })
                            .map(cs => ({ label: cs.name, value: cs.codigo }))}
                        onChange={v => {
                            const values = v ?? [];

                            values.filter(und => und.value !== -1);

                            component.classes = values.map((id: any) => {
                                return new ComponentInteractionClasse().fromJSON({
                                    codigo: -1,
                                    fadClasses: id,
                                    componentInteraction: component.id,
                                });
                            });

                            setAllComponents((prev: any) =>
                                prev.map((c: ComponentInteractionModel) => {
                                    if (c.id === component.id) {
                                        return component;
                                    }
                                    return c;
                                })
                            );
                        }}
                        onBlur={() => {
                            setLoadingButton(numberLoading);
                            handleSaveComponentInteraction(component);
                        }}
                        options={classes.map(c => ({ label: c.name, value: c.codigo }))}
                    />
                </Styled.Column>
                <Divider />
                <AddNewComponent onClick={() => addNewComponente(component.ordem + 1)} />
            </>
        );
    };

    // const fetchAllAnexosByComponents = async (ids: number[]): Promise<any> => {
    //     const requests = ids.map(id => FunctionsFAD.fetchAnexoByComponent(id, false));
    //     const data = await Promise.all(requests);

    //     if (data) {
    //         return data;
    //     }
    // };

    // useFetch(async () => {
    //     if (anexosComponents.length > 0) {
    //         return;
    //     }

    //     if (components.length > 0) {
    //         setAnexoComponent([]);

    //         const ids: number[] = components.map(c => c.id);
    //         setAnexoComponent(await fetchAllAnexosByComponents(ids));
    //     }
    // }, [components]);

    useEffect(() => {
        if (components.length > 0) {
            setAllComponents(components);
        }
    }, [components]);

    useEffect(() => {
        const interval = setInterval(() => {
            setLoaderComponents(false);
        }, 7000);

        return () => clearInterval(interval);
    }, []); // Executa apenas uma vez

    return (
        <Styled.Content.Cotainer>
            <Styled.RowBettween>
                <div style={{ display: 'flex', gap: 16, alignItems: 'center', backgroundColor: Colors.Blue, padding: 22 }}>
                    <Styled.LabelInput style={{ fontSize: 18, color: Colors.White, fontWeight: 600 }}>{dados.title}</Styled.LabelInput>
                    <MdOutlineSettings size={18} cursor={'pointer'} color={Colors.White} onClick={handleSettings} />
                </div>
                <div
                    style={{
                        display: 'flex',
                        gap: 16,
                        alignItems: 'center',
                        padding: 22,
                    }}
                >
                    {dados.isPublic ? <MdPublic size={22} color={Colors.CloneGreen} /> : <HiLockClosed size={22} color={Colors.Grey7} />}
                    <Styled.LabelInput style={{ fontSize: 18, color: dados.isPublic ? Colors.CloneGreen : Colors.Grey7, fontWeight: 600 }}>
                        {dados.isPublic ? 'Conteúdo publicado' : 'Conteúdo privado'}
                    </Styled.LabelInput>
                </div>
            </Styled.RowBettween>
            <Styled.Content.Body>
                {allComponents.length == 0 && loaderComponents && <Skeleton active />}
                {allComponents.length > 0 &&
                    allComponents
                        .sort((a, b) => a.ordem - b.ordem)
                        .map((c: ComponentInteractionModel, i: number) => {
                            if (c.tipo === ComponentInteractionEnum.TEXT) {
                                return (
                                    <div key={c.id}>
                                        <div style={{ backgroundColor: c.cor ?? '' }}>
                                            <ReactQuill
                                                style={{ marginTop: '20px' }}
                                                placeholder="Digite o texto aqui."
                                                theme="snow"
                                                modules={editorConfig.modules}
                                                formats={editorConfig.formats}
                                                value={c.conteudo}
                                                onChange={val =>
                                                    setAllComponents((prev: any) =>
                                                        prev.map((c1: ComponentInteractionModel) => {
                                                            if (c1.id === c.id) {
                                                                return { ...c1, conteudo: val };
                                                            }

                                                            return c1;
                                                        })
                                                    )
                                                }
                                            />
                                        </div>
                                        <ColorPicker
                                            value={c.cor ?? ''}
                                            onChange={v => handleColorComponentInteraction(c.id, v.toHexString())}
                                            style={{ width: 220 }}
                                            showText={color => <span>Cor de fundo ({color.toHexString()})</span>}
                                        />

                                        {FooterOptions(i, c, 1, classes)}
                                    </div>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.AUDIO) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <Styled.Divisor width="100%">
                                            <Styled.Label>URL do áudio</Styled.Label>
                                            <Form.Control
                                                value={c.conteudo}
                                                onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                                                    const newContent = evt.target.value;

                                                    // Atualiza o estado sem modificar diretamente o array anterior
                                                    setAllComponents((prevInteractions: any) =>
                                                        prevInteractions.map((item: any, idx: number) =>
                                                            idx === i ? { ...item, conteudo: newContent } : item
                                                        )
                                                    );
                                                }}
                                            />
                                        </Styled.Divisor>
                                        {FooterOptions(i, c, 2, classes)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.NEXT_INFORMATION) {
                                return (
                                    <>
                                        <FAD_Button_Outline text="Continuar" onClick={() => ''} />
                                        {FooterOptions(i, c, 2, classes)}
                                    </>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.TWO_TEXT) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <Styled.Row>
                                            <ReactQuill
                                                style={{ marginTop: '20px', width: '50%' }}
                                                placeholder="Digite o texto aqui."
                                                theme="snow"
                                                modules={editorConfig.modules}
                                                formats={editorConfig.formats}
                                                value={c.conteudo}
                                                onChange={val =>
                                                    setAllComponents((prev: any) =>
                                                        prev.map((c1: ComponentInteractionModel) => {
                                                            if (c1.id === c.id) {
                                                                return { ...c1, conteudo: val };
                                                            }

                                                            return c1;
                                                        })
                                                    )
                                                }
                                            />
                                            <ReactQuill
                                                style={{ marginTop: '20px', width: '50%' }}
                                                placeholder="Digite o texto aqui."
                                                theme="snow"
                                                modules={editorConfig.modules2}
                                                formats={editorConfig.formats2}
                                                value={c.conteudoTwo}
                                                onChange={val =>
                                                    setAllComponents((prev: any) =>
                                                        prev.map((c1: ComponentInteractionModel) => {
                                                            if (c1.id === c.id) {
                                                                return { ...c1, conteudoTwo: val };
                                                            }

                                                            return c1;
                                                        })
                                                    )
                                                }
                                            />
                                        </Styled.Row>
                                        {FooterOptions(i, c, 3, classes)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.TEXT_IMG_LEFT) {
                                console.log(c);
                                return (
                                    <React.Fragment key={c.id}>
                                        <Styled.RowBettween>
                                            <ImageUpload
                                                base64={anexosComponents.find(a => a.codigoComponent === c.id)?.base64 ?? c.anexo?.base64 ?? ''}
                                                handleUpload={a => handleSaveImg(c.id, a)}
                                                componentStyled={{ width: '920px', height: '620px' }}
                                                componentImgStyled={{ height: '620px' }}
                                                placeholder="Adicione uma imagem"
                                            />
                                            <ReactQuill
                                                style={{ marginTop: '20px', width: '60%' }}
                                                placeholder="Digite o texto aqui."
                                                theme="snow"
                                                modules={editorConfig.modules2}
                                                formats={editorConfig.formats2}
                                                value={c.conteudo}
                                                onChange={val =>
                                                    setAllComponents((prev: any) =>
                                                        prev.map((c1: ComponentInteractionModel) => {
                                                            if (c1.id === c.id) {
                                                                return { ...c1, conteudo: val };
                                                            }

                                                            return c1;
                                                        })
                                                    )
                                                }
                                            />
                                        </Styled.RowBettween>
                                        {FooterOptions(i, c, 4, classes)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.TEXT_IMG_RIGHT) {
                                console.log(c);

                                return (
                                    <React.Fragment key={c.id}>
                                        <Styled.RowBettween>
                                            <ReactQuill
                                                style={{ marginTop: '20px', width: '60%' }}
                                                placeholder="Digite o texto aqui."
                                                theme="snow"
                                                modules={editorConfig.modules2}
                                                formats={editorConfig.formats2}
                                                value={c.conteudo}
                                                onChange={val =>
                                                    setAllComponents((prev: any) =>
                                                        prev.map((c1: ComponentInteractionModel) => {
                                                            if (c1.id === c.id) {
                                                                return { ...c1, conteudo: val };
                                                            }

                                                            return c1;
                                                        })
                                                    )
                                                }
                                            />
                                            <ImageUpload
                                                base64={anexosComponents.find(a => a.codigoComponent === c.id)?.base64 ?? c.anexo?.base64 ?? ''}
                                                handleUpload={a => handleSaveImg(c.id, a)}
                                                componentStyled={{ width: '920px', height: '620px', flexDirection: 'column' }}
                                                componentImgStyled={{ height: '620px' }}
                                                placeholder="Adicione uma imagem"
                                            />
                                        </Styled.RowBettween>
                                        {FooterOptions(i, c, 5, classes)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.TEXT_HIGHLIGHTED) {
                                return (
                                    <div style={{ display: 'flex', flexDirection: 'column', position: 'relative' }} key={c.id}>
                                        <ImageUpload
                                            base64={anexosComponents.find(a => a.codigoComponent === c.id)?.base64 ?? ''}
                                            handleUpload={a => handleSaveImg(c.id, a)}
                                            componentStyled={{ width: '100%', minHeight: '380px' }}
                                            componentImgStyled={{ minHeight: '380px', position: 'absolute' }}
                                            placeholder="Adicione uma imagem"
                                            isVisibleButton
                                        />

                                        <ReactQuill
                                            style={{ marginTop: '20px', width: '100%', position: 'absolute', height: '320px' }}
                                            placeholder="Digite o texto aqui."
                                            theme="snow"
                                            modules={editorConfig.modules2}
                                            formats={editorConfig.formats2}
                                            value={c.conteudo}
                                            onChange={val =>
                                                setAllComponents((prev: any) =>
                                                    prev.map((c1: ComponentInteractionModel) => {
                                                        if (c1.id === c.id) {
                                                            return { ...c1, conteudo: val };
                                                        }

                                                        return c1;
                                                    })
                                                )
                                            }
                                        />

                                        {FooterOptions(i, c, 5, classes)}
                                    </div>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.QUIZ) {
                                return (
                                    <React.Fragment key={c.id}>
                                        {c.quiz &&
                                            c.quiz.map((quiz, index) => {
                                                if (quizIndex === index) {
                                                    return (
                                                        <QuizInteractionAdmin
                                                            key={index}
                                                            dados={quiz}
                                                            maxListQuiz={c.quiz?.length ?? 1}
                                                            myIndex={index + 1}
                                                            component={c}
                                                            handleNewQuiz={() => handleNewQuiz(i)}
                                                            handleNavigateQuiz={v => handleNavigateQuiz(v, c.quiz?.length ?? 1)}
                                                            atualizarPerguntaQuiz={v => atualizarPerguntaQuiz(i, index, v)}
                                                            atualizarFeedbackQuiz={v => atualizarFeedbackQuiz(i, index, v)}
                                                            adicionarNovaAlternativaQuiz={() => adicionarNovaAlternativaQuiz(i, index)}
                                                            atualizarAlternativaQuiz={(indexAlternativa, value) =>
                                                                atualizarAlternativaQuiz(i, index, indexAlternativa, value)
                                                            }
                                                            atualizarCheckAlternativa={(indexAlternativa, checked) =>
                                                                atualizarCheckAlternativa(i, index, indexAlternativa, checked)
                                                            }
                                                            atualizarObrigatory={v => atualizarObrigatoryQuiz(i, v)}
                                                            atualizarMultiplos={v => atualizarMultiplos(i, index, v)}
                                                            removerAlternativaQuiz={v => removerAlternativaQuiz(i, index, v)}
                                                            deletarQuiz={() => deletarQuiz(i, index)}
                                                        />
                                                    );
                                                }
                                            })}
                                        {FooterOptions(i, c, 6, classes)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.REGUA_AVALIATIVA) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <ComponentReguaAvaliativaAdmin dados={c.reguaAvaliativa} codigoInteraction={c.id} />
                                        {FooterOptions(i, c, 7, classes, true, true)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.QUIZ_PONTUACAO) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <ComponentQuizPontucaoAdmin dados={c.quizPontuacao} codigoInteraction={c.id} />
                                        {FooterOptions(i, c, 8, classes, true, true)}
                                    </React.Fragment>
                                );
                            }
                            if (c.tipo === ComponentInteractionEnum.SANFONA) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <Styled.ContentComponentInteractions>
                                            <Divider />
                                            <Styled.Row>
                                                <Select
                                                    defaultValue={c.cor}
                                                    value={c.cor}
                                                    style={{ width: 200, height: 46 }}
                                                    onChange={v => handleSetCor(v, i)}
                                                >
                                                    <Option value={Colors.Blue}>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <ColorPicker value={Colors.Blue} disabledAlpha disabled />
                                                            <p style={{ marginLeft: 10 }}>{Colors.Blue}</p>
                                                        </div>
                                                    </Option>
                                                    <Option value={Colors.SoftBlue}>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <ColorPicker value={Colors.SoftBlue} disabledAlpha disabled />
                                                            <p style={{ marginLeft: 10 }}>{Colors.SoftBlue}</p>
                                                        </div>
                                                    </Option>
                                                    <Option value={Colors.Yellow}>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <ColorPicker value={Colors.Yellow} disabledAlpha disabled />
                                                            <p style={{ marginLeft: 10 }}>{Colors.Yellow}</p>
                                                        </div>
                                                    </Option>
                                                </Select>
                                            </Styled.Row>

                                            <ConfigProvider
                                                collapse={{
                                                    style: {
                                                        backgroundColor: c.cor ?? '',
                                                    },
                                                }}
                                            >
                                                <Collapse
                                                    size="large"
                                                    items={c.sanfona?.map((sanfona, idxSanfona) => ({
                                                        key: idxSanfona.toString(),
                                                        label: (
                                                            <Styled.InputSanfona
                                                                key={idxSanfona}
                                                                placeholder="Título da Sanfona"
                                                                value={sanfona.titulo}
                                                                colorSelected={c.cor ?? ''}
                                                                onChange={e => handleAtualizationTitleSanfona(e.target.value, i, idxSanfona)}
                                                            />
                                                        ),
                                                        children: (
                                                            <SanfonaInteractionAdmin
                                                                key={idxSanfona}
                                                                onChangeValue={(v, tipo, idxConteudo) =>
                                                                    handleAtualizationConteudoSanfona(v, tipo, i, idxSanfona, idxConteudo)
                                                                }
                                                                handleNewConteud={(val: string, tipoConteudo: ComponentInteractionEnum) =>
                                                                    handleAddConteudoSanfona(val, tipoConteudo, i, idxSanfona)
                                                                }
                                                                conteudos={sanfona.componentSanfonaConteudos ?? []}
                                                            />
                                                        ),
                                                    }))}
                                                    expandIcon={({ isActive }) => (
                                                        <StyledCaretRightOutlined
                                                            style={{
                                                                color:
                                                                    c.cor === Colors.Blue || c.cor === Colors.SoftBlue
                                                                        ? Colors.White
                                                                        : Colors.Blue,
                                                            }}
                                                            size={22}
                                                            rotate={isActive ? 90 : 0}
                                                        />
                                                    )}
                                                />
                                            </ConfigProvider>

                                            <Button
                                                onClick={() => handleAddNewAbaSanfona(i)}
                                                style={{ width: 200, backgroundColor: Colors.Yellow2 }}
                                                type="dashed"
                                            >
                                                Adicionar nova aba
                                            </Button>
                                        </Styled.ContentComponentInteractions>
                                        {FooterOptions(i, c, 9, classes)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.CORRESPONDENT) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <CorrespondenciaInteractionAdmin
                                            dadosCorrespondent={c.correspondent}
                                            handleAtualizarInfos={(value, isPerunta) => {
                                                handleAtualizarCorrespondent(i, value, isPerunta);
                                            }}
                                            handleItens={(itens: CorrespondentItemModel[]) => handleItemCorrespondent(i, itens)}
                                        />
                                        {FooterOptions(i, c, 10, classes, false, true)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.CARROSSEL) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <CarrosselInteractionAdmin
                                            items={c.carrossel?.itens ?? []}
                                            handleInfosCarrosel={itens => handleItemCarrossel(i, itens)}
                                        />
                                        {FooterOptions(i, c, 11, classes)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.CARD_BARALHO) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <ComponentBaralhoAdmin
                                            componentInteractionCodigo={c.id}
                                            cardsModels={c.baralho ?? []}
                                            quantityVisible={c.quantityVisible}
                                            atualizarQuantityVisible={(n: number) => atualizarQuantityVisible(i, n)}
                                            isFad
                                        />
                                        {FooterOptions(i, c, 12, classes, true)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.TIMELINE) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <ComponentTimeLineAdmin dados={c.timelines} codigoInteraction={c.id} color={c.cor ?? ''} />
                                        {FooterOptions(i, c, 13, classes, true)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.CENARIO) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <ComponentCenarioAdmin dados={c.cenarios} codigoInteraction={c.id} />
                                        {FooterOptions(i, c, 14, classes, true)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.ABAS) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <Styled.Row style={{ marginBottom: 10 }}>
                                            <Select
                                                defaultValue={c.cor}
                                                value={c.cor}
                                                style={{ width: 200, height: 46 }}
                                                onChange={v => handleSetCor(v, i)}
                                            >
                                                <Option value={Colors.Blue}>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <ColorPicker value={Colors.Blue} disabledAlpha disabled />
                                                        <p style={{ marginLeft: 10 }}>{Colors.Blue}</p>
                                                    </div>
                                                </Option>
                                                <Option value={Colors.SoftBlue}>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <ColorPicker value={Colors.SoftBlue} disabledAlpha disabled />
                                                        <p style={{ marginLeft: 10 }}>{Colors.SoftBlue}</p>
                                                    </div>
                                                </Option>
                                                <Option value={Colors.Yellow}>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <ColorPicker value={Colors.Yellow} disabledAlpha disabled />
                                                        <p style={{ marginLeft: 10 }}>{Colors.Yellow}</p>
                                                    </div>
                                                </Option>
                                            </Select>
                                        </Styled.Row>
                                        <ComponentAbasAdmin
                                            dados={c.abas}
                                            handleAtualizationAbas={abas => handleAbas(i, abas)}
                                            corBackground={c.cor as Colors}
                                        />
                                        {FooterOptions(i, c, 15, classes)}
                                    </React.Fragment>
                                );
                            }

                            if (
                                c.tipo === ComponentInteractionEnum.DIVIDER_LINE ||
                                c.tipo === ComponentInteractionEnum.DIVIDER_LINE_WITH_NUMBER
                            ) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <ComponentDividersAdmin
                                            dados={c}
                                            onChange={v =>
                                                setAllComponents((prev: any) =>
                                                    prev.map((c1: ComponentInteractionModel) => {
                                                        if (c1.id === c.id) {
                                                            return { ...c1, conteudo: v };
                                                        }

                                                        return c1;
                                                    })
                                                )
                                            }
                                        />
                                        {FooterOptions(i, c, 16, classes)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.MARK_TEXT) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <CompontentMarksAdmin
                                            dados={c}
                                            handleColor={v =>
                                                setAllComponents((prev: any) =>
                                                    prev.map((c1: ComponentInteractionModel) => {
                                                        if (c1.id === c.id) {
                                                            return { ...c1, cor: v };
                                                        }

                                                        return c1;
                                                    })
                                                )
                                            }
                                            handleUpdateComponent={comp =>
                                                setAllComponents((prev: any) =>
                                                    prev.map((c1: ComponentInteractionModel) => {
                                                        if (c1.id === c.id) {
                                                            return { ...c1, marks: comp };
                                                        }

                                                        return c1;
                                                    })
                                                )
                                            }
                                        />
                                        {FooterOptions(i, c, 17, classes)}
                                    </React.Fragment>
                                );
                            }
                            if (c.tipo === ComponentInteractionEnum.HOSTPOT) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <ComponentHostPot
                                            dados={c}
                                            hotspots={hostpost}
                                            setHotspots={setHostpost}
                                            handleAttComponent={c => {
                                                setAllComponents((prev: any) =>
                                                    prev.map((c1: ComponentInteractionModel) => {
                                                        if (c1.id === c.id) {
                                                            return c;
                                                        }

                                                        return c1;
                                                    })
                                                );
                                            }}
                                        />
                                        {FooterOptions(i, c, 18, classes)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.ARRASTE_SOLTE) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <ComponentArrasteSolteAdmin codigoInteraction={c.id} dados={c.arrasteSolte} />
                                        {FooterOptions(i, c, 19, classes, true)}
                                    </React.Fragment>
                                );
                            }
                            if (c.tipo === ComponentInteractionEnum.GAME_MEMORY) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <ComponentGameMemoryAdmin codigoInteraction={c.id} dados={c.gameMemorys} />
                                        {FooterOptions(i, c, 20, classes, true)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.LACUNAS) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <ComponentLacunasAdmin
                                            dados={c}
                                            handleAttComponent={c => {
                                                setAllComponents((prev: any) =>
                                                    prev.map((c1: ComponentInteractionModel) => {
                                                        if (c1.id === c.id) {
                                                            return c;
                                                        }

                                                        return c1;
                                                    })
                                                );
                                            }}
                                        />
                                        {FooterOptions(i, c, 21, classes, false)}
                                    </React.Fragment>
                                );
                            }

                            if (c.tipo === ComponentInteractionEnum.CORRESPONDENT_IMAGEM) {
                                return (
                                    <React.Fragment key={c.id}>
                                        <ComponentCorrespondentImagemAdmin
                                            dados={c}
                                            handleAttComponent={c => {
                                                setAllComponents((prev: any) =>
                                                    prev.map((c1: ComponentInteractionModel) => {
                                                        if (c1.id === c.id) {
                                                            return c;
                                                        }

                                                        return c1;
                                                    })
                                                );
                                            }}
                                        />
                                        {FooterOptions(i, c, 22, classes, false)}
                                    </React.Fragment>
                                );
                            }
                        })}

                {allComponents.length == 0 && !loaderComponents && (
                    <>
                        <AddNewComponent onClick={() => addNewComponente(1)} />
                    </>
                )}
            </Styled.Content.Body>
        </Styled.Content.Cotainer>
    );
};

const AdminFadContents = () => {
    const history = useHistory();
    const { setContentSelected, contentSelected, setModuleSelected, moduleSelected } = useContext(FerramentaAutoriaContext.Context);
    const { idCurso, idModulo, idConteudo }: any = useParams();
    const [modules, setModules] = useState<FadModulesModel[]>([]);
    const contentRefs = useRef<Record<string, HTMLDivElement | null>>({});

    //loaders
    const [loadingContent, setLoadingContent] = useState<boolean>(true);

    //Menu
    const [openMenu, setOpenMenu] = useState<boolean>(false);

    //Content
    const [openEditContent, setOpenEditContent] = useState<boolean>(false);
    const [formContent, setFormContent] = useState<FadContentsModel | null>();
    //Module
    const [openEditModule, setOpenEditModule] = useState<boolean>(false);

    const [formModule, setFormModule] = useState<FadModulesModel | null>(null);

    //ListContents
    const [contents, setContents] = useState<FadContentsModel[]>([]);
    const [ordemAdd, setOrdemAdd] = useState<number>(1);
    const [components, setComponents] = useState<ComponentInteractionModel[]>([]);
    const [classes, setClasses] = useState<FadClassesModel[]>([]);

    const serviceContents = new FadContentsService();
    const serviceModules = new FadModulesService();
    const serviceFadRelations = new FadRelationsTemplateService();
    const serviceComponentInteraction = new ComponentInteractionService();
    const serviceModuleAnexo = new FadModulesAnexoService();

    const serviceClasses = new FadClassesService();
    const serviceFadContent = new FadContentsService();

    //Anexo Módulo
    const [anexo, setAnexo] = useState<FadModulesAnexoModel | null>(null);
    const [loadingAnexo, setLoadingAnexo] = useState<boolean>(true);

    //Modal Preview
    const [openModalPreview, setOpenModalPreview] = useState<boolean>(false);

    //helper do scroll
    const { saveScrollPosition, restoreScrollPosition } = useScrollRestore();

    const createUpdateAnexo = async (img: string) => {
        if (moduleSelected) {
            setLoadingAnexo(true);
            let newAnexo = new FadModulesAnexoModel().fromJSON({
                codigo: anexo?.codigo ?? -1,
                codigoFerramentaAutoriaModule: moduleSelected?.codigo,
                filepath: anexo?.filepath ?? '',
                base64: img,
            });

            const { data, status } = await serviceModuleAnexo.create(newAnexo);

            if (status === 201) {
                ToastSuccess('Imagem salva com sucesso!');
                setAnexo(data);
            }
            setLoadingAnexo(false);
        }
    };

    useFetch(async () => {
        const { data, status } = await serviceClasses.findByFadCoursesCodigoPrivate(idCurso);

        if (status === 200) {
            setClasses(data);
        }
    }, [idCurso]);

    useFetch(async () => {
        setAnexo(null);
        setLoadingAnexo(true);

        if (moduleSelected) {
            const { data, status } = await serviceModuleAnexo.findByModule(moduleSelected.codigo, false);

            if (status === 200) {
                data === '' ? setAnexo(null) : setAnexo(data);
            }
            setLoadingAnexo(false);
        }
    }, [moduleSelected]);

    const handleNewComponent = async (tipo: ComponentInteractionEnum) => {
        saveScrollPosition();

        if (contentSelected) {
            const component = new ComponentInteractionSimpleModel().fromJSON({
                id: -1,
                conteudo: '',
                conteudoTwo: '',
                cor: '',
                obrigatory: false,
                quantityVisible: 1,
                tipo: tipo,
                ordem: ordemAdd,
                codigoContent: contentSelected.codigo,
            });

            const { data, status } = await serviceComponentInteraction.insertComponentByFAD(contentSelected.codigo, component);

            if (status === 201) {
                ToastSuccess('Componente criado com sucesso!');
                let componentsAttOrdem = components.filter(c => c.codigoContent === contentSelected.codigo && c.ordem >= ordemAdd);

                setComponents((prev: any) => [...prev, data]);

                await handleAttOrdens(componentsAttOrdem);
            }

            restoreScrollPosition();
        }
    };

    const handleNewTemplate = async (codigoTemplate: number) => {
        const template = await serviceFadRelations.getRelationTemplateByCodigo(codigoTemplate);

        if (template.status === 200 && Array.isArray(template.data) && contentSelected) {
            // Ordenando o array com base na ordem
            const sortedRelations = template.data.sort((a: any, b: any) => a.ordem - b.ordem);

            for (let i = 0; i < sortedRelations.length; i++) {
                const relation = sortedRelations[i];

                // Criando o componente
                const component = new ComponentInteractionSimpleModel().fromJSON({
                    id: -1,
                    conteudo: '',
                    conteudoTwo: '',
                    cor: '',
                    obrigatory: false,
                    quantityVisible: 1,
                    tipo: relation.type as ComponentInteractionEnum,
                    ordem: i > 0 ? ordemAdd + i : ordemAdd,
                    codigoContent: contentSelected.codigo,
                });

                // Inserindo o componente
                const { data, status } = await serviceComponentInteraction.insertComponentByFAD(contentSelected.codigo, component);

                if (status === 201 && data) {
                    const componentsAttOrdem = components.filter(c => c.codigoContent === contentSelected.codigo && c.ordem >= ordemAdd);

                    await handleAttOrdens(componentsAttOrdem);

                    setComponents(prev => [...prev, data]);
                }
            }
            ToastSuccess('Template adicionado com sucesso!');
            setOpenMenu(false);
        } else {
            console.error('Erro: template.data não é um array ou contentSelected está ausente.');
        }
    };

    const handleAttOrdens = async (components: ComponentInteractionModel[]) => {
        let newListComponents: ComponentInteractionModel[] = [];

        components.forEach(async c => {
            c.ordem = c.ordem + 1;

            const { data, status } = await serviceComponentInteraction.atualizarOrdem(c);

            if (status === 200) {
                newListComponents.push(data);
            }
        });

        setComponents((prev: ComponentInteractionModel[]) =>
            prev.map(c => {
                const updatedComponent = newListComponents.find(updated => updated.id === c.id);
                return updatedComponent ? updatedComponent : c; // Retorna o componente atualizado ou o original
            })
        );
    };

    const fetchComponents = async () => {
        setComponents([]); // Limpa os componentes inicialmente

        if (contentSelected) {
            const { data, status } = await serviceComponentInteraction.fetchComponentsByFAD(contentSelected.codigo, false);

            if (status === 200) {
                setComponents((prev: any) => {
                    const idsExistentes = new Set(prev.map((item: any) => item.id));
                    const novosComponentes = data.filter((item: any) => !idsExistentes.has(item.id));
                    return [...prev, ...novosComponentes];
                });
            }
        }
    };

    useFetch(async () => {
        await fetchComponents();
    }, [moduleSelected, contentSelected]);

    useFetch(async () => {
        if (idCurso && idCurso !== -1) {
            const { data, status } = await serviceModules.findByFadCoursesCodigo(idCurso);

            if (status === 200) {
                setModules(data);
                if (data) {
                    const modulo = data.find((d: FadModulesModel) => d.codigo === parseInt(idModulo));

                    if (modulo) {
                        setModuleSelected(modulo);
                        setFormModule(modulo);
                    }
                }
            }
        }
    }, [idCurso, idModulo]);

    useFetch(
        async () => {
            if (moduleSelected && moduleSelected.codigo !== -1) {
                const { data, status } = await serviceContents.findByFadModulesCodigo(moduleSelected?.codigo);

                if (status === 200) {
                    setContents(data.map((c: any) => ({ ...c, codigoFerramentaAutoriaModule: moduleSelected?.codigo })));
                }
            }
        },
        [moduleSelected],
        setLoadingContent
    );

    const handleChange = (value: string) => {
        modules.forEach((m, i) => {
            if (m.codigo === parseInt(value)) {
                history.push(`/admin/ferramenta-autoria/curso/${idCurso}/${m.codigo}/conteudo/${contentSelected?.codigo}`);
                setModuleSelected(m);
                setFormModule(m);
                return;
            }
        });
    };
    const handleChangeContent = (value: string) => {
        contents.forEach((c, i) => {
            if (c.codigo === parseInt(value)) {
                const contentSelect = contents.filter(c => c.codigo === parseInt(value))[0];

                setContentSelected(contentSelect);
                return;
            }
        });
    };

    const newOrdem = (): number => {
        return contents?.at(-1)?.ordem ? contents.at(-1)!.ordem + 1 : 1;
    };

    const handleCreateNewContent = async () => {
        if (moduleSelected) {
            const dataContent = new FadContentsModel().fromJSON({
                codigo: -1,
                title: 'Titulo do conteúdo ' + newOrdem(),
                codigoFerramentaAutoriaModule: moduleSelected?.codigo,
                isPublic: false,
                activeAvaliations: false,
                activeCommentary: false,
                corText: Colors.Blue,
                textFontSize: 38,
                ordem: newOrdem(),
            });

            const { data, status } = await serviceContents.create(dataContent);

            if (status === 201) {
                const novoConteudo = { ...data, codigoFerramentaAutoriaModule: moduleSelected?.codigo };

                setContentSelected(novoConteudo);
                setContents((prev: any) => [...prev, novoConteudo]);
            }
        }
    };

    const handleUpdate = async (attPublic?: boolean) => {
        if (moduleSelected && formModule) {
            let form = new FadModulesModel().fromJSON({
                ...formModule,
                isPublic: attPublic ? !moduleSelected.isPublic : moduleSelected.isPublic,
            });

            const { data, status } = await serviceModules.update(moduleSelected.codigo, form);

            if (status === 200) {
                ToastSuccess('Módulo atualizado com sucesso!');

                setModuleSelected(data);

                setModules((prev: FadModulesModel[]) =>
                    prev.map(m => {
                        if (m.codigo === moduleSelected.codigo) {
                            return data;
                        }

                        return m;
                    })
                );
            }

            setOpenEditModule(false);
        }
    };

    const handleUpdateContent = async () => {
        if (formContent && moduleSelected) {
            formContent.codigoFerramentaAutoriaModule = moduleSelected.codigo;

            const { data, status } = await serviceContents.update(formContent.codigo, formContent);

            if (status === 200) {
                ToastSuccess('Conteúdo atualizado com sucesso!');
                setContents((prev: FadContentsModel[]) => {
                    return prev.map(item =>
                        item.codigo === data.codigo ? { ...data, codigoFerramentaAutoriaModule: moduleSelected.codigo } : item
                    );
                });
            }

            setOpenEditContent(false);
        }
    };

    const removeModuleList = (codigo: number) => {
        setModules((prev: FadModulesModel[]) => prev.filter(m => m.codigo !== codigo));
    };

    const deleteModule = async (module: FadModulesModel) => {
        const { status } = await serviceModules.delete(module.codigo);

        if (status === 204) {
            ToastSuccess('Módulo removido com sucesso!');
            removeModuleList(module.codigo);
            setOpenEditModule(false);
        }
    };

    const handlePreview = () => {
        if (components.length > 0 && contentSelected) {
            setOpenModalPreview(true);
        }
    };

    const handleRemoveContent = (codigo: number) => {
        setContents((prev: FadContentsModel[]) => prev.filter(c => c.codigo !== codigo));
    };

    const deleteContent = async (content: FadContentsModel) => {
        const { status } = await serviceFadContent.delete(content.codigo);

        if (status === 204) {
            ToastSuccess('Conteúdo removido com sucesso!');
            handleRemoveContent(content.codigo);
            setOpenEditContent(false);
        }
    };

    const goToBack = () => {
        history.push(`/admin/ferramenta-autoria/curso/${idCurso}`);
    };

    useEffect(() => {
        if (idConteudo && idConteudo != -1) {
            const contentSelect = contents.filter(c => c.codigo === idConteudo)[0];
            setContentSelected(contentSelect);
        } else {
            const contentSelect = contents.sort((a, b) => a.ordem - b.ordem)[0];
            setContentSelected(contentSelect);
        }
    }, [idConteudo, contents]);

    useEffect(() => {
        if (moduleSelected) {
            const contentSelect = !contentSelected
                ? contents.filter(c => c.codigoFerramentaAutoriaModule === moduleSelected?.codigo)[0]
                : contentSelected;

            if (contentSelect) {
                handleChangeContent(contentSelect.codigo.toString());
            }
        }
    }, [moduleSelected, contents]);

    return (
        <>
            <AdminModalFadPreview openModal={openModalPreview} setOpenModal={setOpenModalPreview} anexo={anexo} components={components} />
            <Styled.Container style={{ display: openModalPreview ? 'none' : 'flex' }}>
                <Styled.Header>
                    <FAD_Button_Outline icon={<IoIosArrowBack />} text="Voltar" onClick={goToBack} />
                    <ConfigProvider
                        theme={{
                            token: {
                                colorBgBase: '#FFF',
                                colorBorder: '#FFF',
                                colorText: Colors.Blue,
                                fontSize: 22,
                            },
                        }}
                        select={{
                            style: {},
                        }}
                    >
                        <Select
                            style={{ width: 400 }}
                            size="large"
                            value={moduleSelected?.title}
                            onChange={handleChange}
                            options={modules.map((m, i) => ({ label: m.title, value: m.codigo }))}
                        />
                        <Select
                            style={{ width: 400 }}
                            size="large"
                            value={contentSelected ? contentSelected?.title : contents.sort((a, b) => a.ordem - b.ordem)[0]?.title}
                            onChange={handleChangeContent}
                            options={contents
                                .filter(c => c.codigoFerramentaAutoriaModule === moduleSelected?.codigo)
                                .sort((a, b) => a.ordem - b.ordem)
                                .map(dados => ({ label: dados.title, value: dados.codigo }))}
                        />
                    </ConfigProvider>

                    <Styled.Buttons>
                        <FAD_Button_Outline icon={<FaPlay />} text="Preview" onClick={() => handlePreview()} />
                        <FAD_Button_Primary
                            disabled={anexo === null}
                            icon={moduleSelected?.isPublic ? <HiLockClosed size={22} /> : <BsFillSendFill />}
                            text={moduleSelected?.isPublic ? 'Despublicar' : 'Publicar'}
                            styles={{ backgroundColor: moduleSelected?.isPublic ? Colors.Yellow2 : Colors.Blue }}
                            onClick={() => {
                                handleUpdate(true);
                            }}
                        />
                    </Styled.Buttons>
                </Styled.Header>

                {/** Módulo selecionado */}
                <Styled.ContentInfoModule.Container>
                    <Styled.Row style={{ alignItems: 'center' }}>
                        {moduleSelected?.isPublic ? (
                            <MdPublic size={22} color={Colors.CloneGreen} />
                        ) : (
                            <HiLockClosed size={22} color={Colors.Grey7} />
                        )}
                        <Styled.LabelInput
                            style={{ fontSize: 18, color: moduleSelected?.isPublic ? Colors.CloneGreen : Colors.Grey7, fontWeight: 600 }}
                        >
                            {moduleSelected?.isPublic ? 'Módulo publicado' : 'Módulo privado'}
                        </Styled.LabelInput>
                    </Styled.Row>

                    {/* {Adicionar o preview do banner}    */}
                    {loadingAnexo ? (
                        <Skeleton.Image style={{ width: '100%', height: '320px' }} active />
                    ) : (
                        <ImageUpload
                            base64={anexo?.base64 ?? ''}
                            handleUpload={a => createUpdateAnexo(a)}
                            componentStyled={{ width: '100%', height: '320px' }}
                            componentImgStyled={{ height: '320px' }}
                        />
                    )}

                    <Styled.LabelInput>Nome do módulo</Styled.LabelInput>

                    <Styled.RowBettween>
                        <Styled.TitleLarge>{moduleSelected?.title}</Styled.TitleLarge>

                        <MdEditSquare size={28} cursor={'pointer'} color={Colors.Yellow2} onClick={() => setOpenEditModule(true)} />
                    </Styled.RowBettween>
                </Styled.ContentInfoModule.Container>

                {loadingContent ? (
                    <>
                        <Skeleton active />
                    </>
                ) : (
                    <>
                        {contents
                            .filter(cFilter => cFilter.codigo === contentSelected?.codigo)
                            .sort((a, b) => a.ordem - b.ordem)
                            .map((c, i) => (
                                <div key={c.codigo} ref={el => (contentRefs.current[c.codigo] = el)}>
                                    <Contents
                                        dados={c}
                                        addNewComponente={ordem => {
                                            setContentSelected(c);
                                            setOrdemAdd(ordem);
                                            setOpenMenu(true);
                                        }}
                                        components={components.sort((a, b) => a.ordem - b.ordem).filter(f => f.codigoContent === c.codigo)}
                                        handleSettings={() => {
                                            setFormContent(c);
                                            setContentSelected(c);
                                            setOpenEditContent(true);
                                        }}
                                        attComponents={setComponents}
                                        classes={classes}
                                    />
                                </div>
                            ))}

                        <FadAdds onClick={handleCreateNewContent} textPopover="Adicionar um novo conteúdo" />
                    </>
                )}

                <AdminFadMenuLateral
                    open={openMenu}
                    setHidden={() => setOpenMenu(false)}
                    handleCreateComponent={tipo => handleNewComponent(tipo)}
                    handleAddTemplate={codigoTemplate => handleNewTemplate(codigoTemplate)}
                />

                <ModalFormModule
                    form={formModule ?? new FadModulesModel()}
                    handleEdit={handleUpdate}
                    handleSave={() => ''}
                    handleHidden={() => setOpenEditModule(false)}
                    setForm={setFormModule}
                    open={false}
                    openEdit={openEditModule}
                    loading={false}
                    removeModule={deleteModule}
                />

                <ModalFormContent
                    open={false}
                    openEdit={openEditContent}
                    setForm={setFormContent}
                    form={formContent ?? new FadContentsModel()}
                    handleEdit={handleUpdateContent}
                    handleSave={() => ''}
                    handleHidden={() => setOpenEditContent(false)}
                    loading={false}
                    handleDelete={deleteContent}
                />

                {/* {Adicionando a setinha para ir ao todo da página} */}

                <div
                    onClick={() => window.scroll(0, 0)}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'fixed',
                        borderRadius: 100,
                        width: 100,
                        height: 38,
                        top: 24,
                        right: 220,
                        backgroundColor: Colors.Blue,
                        cursor: 'pointer',
                        zIndex: 100,
                    }}
                >
                    <MdArrowUpward color="white" size={28} />
                </div>
            </Styled.Container>
        </>
    );
};

export default AdminFadContents;
